
<div class="border border-solid border-neutral-200 px-6 rounded-xl lg:w-4/5 mx-auto py-5">
  <div class="gap-5 flex items-center justify-evenly flex-wrap">
    <div [routerLink]="[item.Url]" *ngFor="let item of dataSource?.Data?.Details.slice().reverse(); let index = index"
      class="bg-white rounded-2xl flex flex-col items-center justify-center py-2 md-min-w-auto min-w-[88px] hover:bg-slate-50 cursor-pointer duration-300 transition-all">
      <a  [routerLink]="item.Url" class="w-full flex flex-col items-center justify-center ">
        <img [src]=" '/assets/images/ecolodgeTypes/' + (index + 1) + '.svg'">
        <span class="mt-2 text-base text-neutral-600 text-center !font-medium">
          {{item.Name}}
        </span>
      </a>
    </div>
  </div>
</div>